import PeriodField from '@cnamts/vue-dot/src/patterns/PeriodField'

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(PeriodField,_vm._b({attrs:{"value":_vm.field.value,"vuetify-options":_vm.field.fieldOptions,"outlined":""},on:{"change":_vm.emitChangeEvent}},'PeriodField',_vm.field.fieldOptions,false))
}
var staticRenderFns = []

export { render, staticRenderFns }